/* =========================================================
   Sopora — collection & search facets
   In-place filtering + sorting via the Section Rendering API,
   load-more / infinite scroll, and a mobile filter drawer.
   Progressive enhancement: without JS the form GET-reloads.
   ========================================================= */
(function () {
  'use strict';

  document.querySelectorAll('[data-collection-section]').forEach(function (root) {
    var sectionId = root.getAttribute('data-collection-section');
    var baseUrl = root.getAttribute('data-base-url') || window.location.pathname;
    var loadMoreMode = root.getAttribute('data-load-mode'); // 'button' | 'infinite' | ''
    var busy = false;

    function panel() { return root.querySelector('[data-facets-panel]'); }
    function results() { return root.querySelector('[data-product-results]'); }

    /* ---------- Build a filtered URL from the facets form ---------- */
    function buildUrl(extraSort) {
      var form = root.querySelector('[data-facets-form]');
      var params = new URLSearchParams();
      if (form) {
        new FormData(form).forEach(function (value, key) {
          if (value !== '' && value != null) params.append(key, value);
        });
      }
      var sortSel = root.querySelector('[data-sort]');
      var sortVal = extraSort || (sortSel && sortSel.value);
      if (sortVal) { params.delete('sort_by'); params.set('sort_by', sortVal); }
      var qs = params.toString();
      return baseUrl + (qs ? '?' + qs : '');
    }

    function fetchSection(url) {
      var join = url.indexOf('?') === -1 ? '?' : '&';
      return fetch(url + join + 'section_id=' + sectionId, { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.text(); })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
    }

    /* ---------- Apply a filtered/sorted URL in place ---------- */
    function apply(url) {
      if (busy) return;
      busy = true;
      root.classList.add('is-loading');
      fetchSection(url).then(function (doc) {
        var freshPanel = doc.querySelector('[data-facets-panel]');
        var freshResults = doc.querySelector('[data-product-results]');
        if (freshPanel && panel()) panel().innerHTML = freshPanel.innerHTML;
        if (freshResults && results()) results().innerHTML = freshResults.innerHTML;
        history.pushState({ soporaFacets: true }, '', url);
        if (window.SoporaReveal) window.SoporaReveal(results());
        bindLoadMore();
        var top = root.getBoundingClientRect().top + window.scrollY - 120;
        if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
      }).catch(function () {
        window.location.href = url;
      }).finally(function () {
        busy = false;
        root.classList.remove('is-loading');
      });
    }

    /* ---------- Events: filter change, submit, sort, clear ---------- */
    var debounce;
    root.addEventListener('input', function (e) {
      if (!e.target.closest('[data-facets-form]')) return;
      if (e.target.type === 'number') return; // wait for Apply on price
      clearTimeout(debounce);
      debounce = setTimeout(function () { apply(buildUrl()); }, 250);
    });
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-sort]')) { apply(buildUrl(e.target.value)); }
    });
    root.addEventListener('submit', function (e) {
      if (e.target.matches('[data-facets-form]')) { e.preventDefault(); apply(buildUrl()); }
    });
    var facetsToggle = root.querySelector('[data-facets-open]');
    function openFacets() {
      root.classList.add('facets-open');
      document.documentElement.style.overflow = 'hidden';
      if (facetsToggle) facetsToggle.setAttribute('aria-expanded', 'true');
      var first = panel() && panel().querySelector('[data-facets-close]');
      if (first) first.focus();
    }
    function closeFacets() {
      if (!root.classList.contains('facets-open')) return;
      root.classList.remove('facets-open');
      document.documentElement.style.overflow = '';
      if (facetsToggle) { facetsToggle.setAttribute('aria-expanded', 'false'); facetsToggle.focus(); }
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-facets-clear]')) { e.preventDefault(); apply(baseUrl); }
      if (e.target.closest('[data-facets-open]')) openFacets();
      if (e.target.closest('[data-facets-close]')) closeFacets();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFacets(); });

    window.addEventListener('popstate', function () { apply(window.location.href); });

    /* ---------- Load more / infinite scroll ---------- */
    function bindLoadMore() {
      if (!loadMoreMode) return;
      var res = results();
      if (!res) return;
      var pagination = res.querySelector('.pagination');
      if (!pagination) return;
      var nextLink = pagination.querySelector('a[href]:last-of-type, [rel="next"]');
      // find the "next" URL: last numeric/next anchor that points forward
      var next = res.querySelector('.pagination [rel="next"]') || findNext(pagination);
      pagination.style.display = 'none';
      if (!next) return;

      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'btn btn--secondary load-more';
      trigger.textContent = 'Load more';
      pagination.parentNode.insertBefore(trigger, pagination);

      function loadNext() {
        if (busy || !trigger.dataset.href && !next) return;
        var url = trigger.dataset.href || next.getAttribute('href');
        busy = true; trigger.classList.add('is-loading');
        fetchSection(url).then(function (doc) {
          var grid = res.querySelector('.product-grid');
          var freshGrid = doc.querySelector('[data-product-results] .product-grid');
          if (grid && freshGrid) {
            while (freshGrid.firstElementChild) grid.appendChild(freshGrid.firstElementChild);
            if (window.SoporaReveal) window.SoporaReveal(grid);
          }
          var freshNext = doc.querySelector('[data-product-results] .pagination [rel="next"]') || findNext(doc.querySelector('[data-product-results] .pagination'));
          if (freshNext) { trigger.dataset.href = freshNext.getAttribute('href'); }
          else { trigger.remove(); if (observer) observer.disconnect(); }
        }).finally(function () { busy = false; trigger.classList.remove('is-loading'); });
      }

      trigger.addEventListener('click', loadNext);

      var observer;
      if (loadMoreMode === 'infinite' && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) loadNext();
        }, { rootMargin: '400px' });
        observer.observe(trigger);
      }
    }

    function findNext(pagination) {
      if (!pagination) return null;
      // current page has no href; the anchor immediately after the current marker is "next"
      var current = pagination.querySelector('[aria-current], .pagination__current, .current');
      if (current) {
        var sib = current.nextElementSibling;
        while (sib && sib.tagName !== 'A') sib = sib.nextElementSibling;
        if (sib) return sib;
      }
      var anchors = pagination.querySelectorAll('a[href]');
      return anchors.length ? anchors[anchors.length - 1] : null;
    }

    bindLoadMore();
  });
})();
